import { render } from "./ConceptDetail.vue?vue&type=template&id=84d1242c&scoped=true"
import script from "./ConceptDetail.vue?vue&type=script&lang=js"
export * from "./ConceptDetail.vue?vue&type=script&lang=js"

import "./ConceptDetail.vue?vue&type=style&index=0&id=84d1242c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d1242c"]])

export default __exports__